import type { PartnerModel } from '@/types/partners/PartnerModel'
import type { ExtendedPrimitives } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import type { DetectionStats } from './DetectionStats'
import type { AssociatedDeviceModel } from './DeviceModel'
import type { PartnerConfigModel } from './PartnerConfigModel'

export type EventModel = {
    comments?: string
    end_at?: Date | null
    id: number
    latestDetections?: string[]
    detection_devices?: AssociatedDeviceModel[]
    detections_stats?: DetectionStats

    name: string
    start_at?: Date | null

    guntimes?: { name: string; start_at: Date }[]
    data?: Record<string, ExtendedPrimitives>

    organization_id?: number

    partner?: PartnerModel
    partner_config?: Partial<PartnerConfigModel>
    partner_id?: number

    tz?: string

    sync?: boolean
}

export const defaultEventModel: EventModel = {
    end_at: moment().endOf('d').toDate(),
    id: 0,
    name: '',
    start_at: moment().startOf('d').toDate()
}
